function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// @mui imports
import MuiButton from "@mui/material/Button";
// @limitless
import { useTranslation } from "@limitless/common/hooks";
const Button = ({
  children,
  id = "button-default-id",
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(MuiButton, _extends({
    id: id,
    disableElevation: true,
    disableRipple: true
  }, rest, {
    sx: {}
  }), typeof children === "string" ? t(children) : children);
};
Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  id: PropTypes.string
};
export default Button;